import React, { useEffect, useRef, useState } from "react";
import data from "../../json/landingpage/testimonial.json";
import { ReactComponent as Icon } from "../../Icons/whitearrow.svg";
import parse from "html-react-parser";
const Testimonialnew = () => {
  const [currentItem, setCurrentItem] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [widthTimes, setWidthTimes] = useState(1);
  const [width, setWidth] = useState();
  const [startX, setStartX] = useState(null);
  const [id, setId] = useState(0);
  const ref = useRef();

  let truncatedtext = data.comments.map((el, i) =>
    el.view.length > 200 ? el.view.slice(0, 200) : el.view
  );

  useEffect(() => {
    setWidthTimes(data.comments.length);
  }, []);

  useEffect(() => {
    setWidth(ref.current.clientWidth);

    let handleWidth = () => {
      if (ref.current) {
        let width = ref.current.clientWidth;
        setWidth(width);
      }
    };
    window.addEventListener("resize", handleWidth);
    return () => window.removeEventListener("resize", handleWidth);
  }, []);

  const togglereadmore = (index) => {
    setId(index);
    setExpanded(true);
  };

  const handlePrevious = () => {
    setCurrentItem((prev) => (prev > 0 ? prev - 1 : prev));
    setExpanded(false);
  };

  const handleNext = () => {
    if (width > 768) {
      setCurrentItem((prev) => (prev < widthTimes - 1 ? prev + 1 : prev));
    } else {
      setCurrentItem((prev) => (prev < widthTimes - 1 ? prev + 1 : prev));
    }
    setExpanded(false);
  };

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    if (!startX) return;

    const currentX = e.touches[0].clientX;
    const diffX = startX - currentX;

    if (diffX > 50) {
      handleNext();
      setStartX(null);
    } else if (diffX < -50) {
      handlePrevious();
      setStartX(null);
    }
  };

  console.log(width);

  return (
    <div className="w-full flex justify-center ">
      <div className="2xl:container w-full p-4 lg:px-20 py-12 ">
        <div className="flex justify-center">
          <h4 className="text-20 min-[450px]:text-24 md:text-36 text-primarycolor lg:text-48 font-semibold">{parse(data.Title)}</h4>
        </div>
        <div className="flex mt-2 md:mt-12 justify-center items-center">
          <div className="w-full md:w-[90%] flex justify-center md:gap-5 items-center">
            <button
              onClick={handlePrevious}
              className="hidden md:flex h-[45px] w-[45px] rounded-full border-[1px] border-highlight hover:bg-ctaorange flex justify-center items-center testibtn"
            >
              <Icon className="rotate-180 text-highlight arrowicon" />
            </button>
            <div
              ref={ref}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              className="flex w-full md:w-10/12 relative overflow-hidden"
            >
              <div
                className={`relative flex w-[${width * data.comments.length
                  }] transistion-transform duration-300`}
                style={{
                  transform: `translateX(-${(currentItem * width)}px)`,
                }}
              >
                {data.comments.map((comm, index) => (
                  <div
                    key={index}
                    className="p-[25px] flex items-center h-full"
                    style={{ width: width ? `${width}px` : "966px" }}
                  >
                    <div className={`px-4 h-full md:px-8 py-4 md:py-8 flex flex-col-reverse max-md:justify-between md:flex-row items-start gap-6 md:gap-8 bg-white rounded-[16px] shadow-services`}
                    >
                    <div className="w-auto max-md:flex items-center gap-2">
                      <img
                        className="w-auto h-[40px] lg:h-[80px] rounded-full"
                        src={
                          process.env.PUBLIC_URL +
                          `${comm.gender === "male"
                            ? comm.imgmale
                            : comm.imgfemale
                          }`
                        }
                        alt="profile_img"
                      />
                      <h1 className="md:hidden text-left text-16 font-semibold text-primarycolor">
                        {comm.Name}
                      </h1>
                    </div>
                    <div className="flex flex-col w-full md:w-[85%] gap-6">
                      <h1 className="max-md:hidden text-center md:text-left text-18 md:text-24 font-semibold text-primarycolor">
                        {comm.Name}
                      </h1>
                      <p className=" text-left text-16 md:text-18 text-secondaryblack">
                        {index === id && expanded
                          ? comm.view
                          : `${truncatedtext[index]}  `}
                        <span>
                          {comm.view.length > 400 && (
                            <button
                              onClick={() => togglereadmore(index)}
                              className="text-F74900"
                            >
                              {index === id && expanded ? "" : "Read More"}
                            </button>
                          )}
                        </span>
                      </p>
                    </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button
              onClick={handleNext}
              className="hidden md:flex h-[45px] w-[45px] rounded-full border-[1px] border-highlight hover:bg-ctaorange flex justify-center items-center testibtn"
            >
              <Icon className="text-highlight arrowicon" />
            </button>
          </div>
        </div>
         <div className="flex gap-5 text-white md:mt-5 w-full justify-center min-[768px]:hidden">
                  <button
                    onClick={handlePrevious}
                    className=" flex h-[45px] w-[45px]  rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
                  >
                    <Icon className="text-highlight arrowicon rotate-180" />
                  </button>
                  <button
                    onClick={handleNext}
                    className="flex h-[45px] w-[45px] rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
                  >
                    <Icon className="text-highlight arrowicon" />
                  </button>
        
                </div>
      </div>
    </div>
  );
};

export default Testimonialnew;
